module.exports = __webpack_public_path__ + "static/media/1.4 Barbara Details Faltenwurf.74bcd4ac.jpg";